<script>
	const BOUNDARY_VALUES = {
		// these values track where on the slider the color changes
		0: 0,
		973: 1,
		2010: 2,
		3040: 3,
		3999: 4
	};

	const SLIDER_STOPS = {
		0: 0,
		1: 470,
		2: 1484,
		3: 2530,
		4: 3565
	};

	const SLIDER_STOPS_REVERSE = Object.keys(SLIDER_STOPS).reduce((o, stop) => {
		const internalValue = SLIDER_STOPS[stop];
		o[internalValue] = parseInt(stop);
		return o;
	}, {});

	export default {
		props: {
			value: {
				type: Number,
				default: 0
			},
			readonly: {
				type: Boolean,
				default: false
			}
		},
		data() {
			let internalValue = SLIDER_STOPS[this.value || 0];

			return {
				SLIDER_STOPS_REVERSE,
				internalValue
			};
		},
		watch: {
			internalValue: {
				handler: function (v) {
					if (typeof BOUNDARY_VALUES[v] === 'undefined') {
						let closest = null,
							closestDiff = 1000000;
						Object.keys(BOUNDARY_VALUES).forEach(allowedVal => {
							const diff = Math.abs(allowedVal - v);
							if (allowedVal >= v && diff < closestDiff) {
								closest = allowedVal;
								closestDiff = diff;
							}
						});
						v = closest;
					}

					this.internalValue = SLIDER_STOPS[BOUNDARY_VALUES[v]];
					this.$emit('update-value', BOUNDARY_VALUES[v]);
				},
				immediate: true
			}
		}
	};
</script>
<template>
	<span class="vocab-rate-words-slider">
		<input
			:disabled="readonly"
			ref="slider"
			min="0"
			max="3999"
			type="range"
			v-model="internalValue"
			:class="{
				'slider-value-0': SLIDER_STOPS_REVERSE[internalValue] === 0 || typeof SLIDER_STOPS_REVERSE[internalValue] === 'undefined',
				'slider-value-1': SLIDER_STOPS_REVERSE[internalValue] === 1,
				'slider-value-2': SLIDER_STOPS_REVERSE[internalValue] === 2,
				'slider-value-3': SLIDER_STOPS_REVERSE[internalValue] === 3,
				'slider-value-4': SLIDER_STOPS_REVERSE[internalValue] === 4
			}" />
	</span>
</template>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.vocab-rate-words-slider {
		$slider-0-fill: linear-gradient(
			90deg,
			$c-rate-words-slider-color1-muted 0%,
			$c-rate-words-slider-color1-muted 25%,
			$c-rate-words-slider-color2-muted 25%,
			$c-rate-words-slider-color2-muted 50%,
			$c-rate-words-slider-color3-muted 50%,
			$c-rate-words-slider-color3-muted 75%,
			$c-rate-words-slider-color4-muted 75%,
			$c-rate-words-slider-color4-muted
		);

		$slider-1-fill: linear-gradient(
			90deg,
			$c-rate-words-slider-color1 0%,
			$c-rate-words-slider-color1 25%,
			$c-rate-words-slider-color2-muted 25%,
			$c-rate-words-slider-color2-muted 50%,
			$c-rate-words-slider-color3-muted 50%,
			$c-rate-words-slider-color3-muted 75%,
			$c-rate-words-slider-color4-muted 75%,
			$c-rate-words-slider-color4-muted
		);

		$slider-2-fill: linear-gradient(
			90deg,
			$c-rate-words-slider-color1 0%,
			$c-rate-words-slider-color1 25%,
			$c-rate-words-slider-color2 25%,
			$c-rate-words-slider-color2 50%,
			$c-rate-words-slider-color3-muted 50%,
			$c-rate-words-slider-color3-muted 75%,
			$c-rate-words-slider-color4-muted 75%,
			$c-rate-words-slider-color4-muted
		);

		$slider-3-fill: linear-gradient(
			90deg,
			$c-rate-words-slider-color1 0%,
			$c-rate-words-slider-color1 25%,
			$c-rate-words-slider-color2 25%,
			$c-rate-words-slider-color2 50%,
			$c-rate-words-slider-color3 50%,
			$c-rate-words-slider-color3 75%,
			$c-rate-words-slider-color4-muted 75%,
			$c-rate-words-slider-color4-muted
		);

		$slider-4-fill: linear-gradient(
			90deg,
			$c-rate-words-slider-color1 0%,
			$c-rate-words-slider-color1 25%,
			$c-rate-words-slider-color2 25%,
			$c-rate-words-slider-color2 50%,
			$c-rate-words-slider-color3 50%,
			$c-rate-words-slider-color3 75%,
			$c-rate-words-slider-color4 75%,
			$c-rate-words-slider-color4
		);

		input[type='range'] {
			width: 100%;
			background: transparent;
			display: inline;
			-webkit-appearance: none;
			padding: 0;
		}
		input[type='range']::-webkit-slider-runnable-track {
			width: 100%;
			height: 0.7rem;
			margin-top: 0.3rem;
			background-position: left;
			background-size: 100%;
			background-repeat: no-repeat;
			border-radius: 0;
			border: 1px solid $c-slate;
		}
		input[type='range'].slider-value-0::-webkit-slider-runnable-track {
			background-image: $slider-0-fill;
		}
		input[type='range'].slider-value-1::-webkit-slider-runnable-track {
			background-image: $slider-1-fill;
		}
		input[type='range'].slider-value-2::-webkit-slider-runnable-track {
			background-image: $slider-2-fill;
		}
		input[type='range'].slider-value-3::-webkit-slider-runnable-track {
			background-image: $slider-3-fill;
		}
		input[type='range'].slider-value-4::-webkit-slider-runnable-track {
			background-image: $slider-4-fill;
		}

		input[type='range']::-webkit-slider-thumb {
			-webkit-appearance: none;
			border: 1px solid $c-slate;
			height: 1.1rem;
			width: 1.1rem;
			border-radius: 50%;
			background: #ffffff;
			cursor: pointer;
			margin-top: -0.27rem;
		}

		input[type='range']::-moz-range-track {
			width: 100%;
			height: 0.7rem;
			background-position: left;
			background-size: 100%;
			background-repeat: no-repeat;
			border-radius: 0;
			border: 1px solid $c-slate;
		}
		input[type='range'].slider-value-0::-moz-range-track {
			background-image: $slider-0-fill;
		}
		input[type='range'].slider-value-1::-moz-range-track {
			background-image: $slider-1-fill;
		}
		input[type='range'].slider-value-2::-moz-range-track {
			background-image: $slider-2-fill;
		}
		input[type='range'].slider-value-3::-moz-range-track {
			background-image: $slider-3-fill;
		}
		input[type='range'].slider-value-4::-moz-range-track {
			background-image: $slider-4-fill;
		}

		input[type='range']::-moz-range-thumb {
			-webkit-appearance: none;
			border: 1px solid $c-slate;
			height: 1.1rem;
			width: 1.1rem;
			border-radius: 50%;
			background: #ffffff;
			cursor: pointer;
			margin-top: -0.27rem;
		}

		input[type='range']::-ms-track {
			// this represents the background of the range.
			height: 0.7rem;
			border-radius: 0;
			border: 1px solid $c-slate;
			color: transparent;
			margin-top: 0.13rem;
		}
		input[type='range'].slider-value-0::-ms-track {
			background-image: $slider-0-fill;
		}
		input[type='range'].slider-value-1::-ms-track {
			background-image: $slider-1-fill;
		}
		input[type='range'].slider-value-2::-ms-track {
			background-image: $slider-2-fill;
		}
		input[type='range'].slider-value-3::-ms-track {
			background-image: $slider-3-fill;
		}
		input[type='range'].slider-value-4::-ms-track {
			background-image: $slider-4-fill;
		}

		input[type='range']::-ms-tooltip {
			display: none;
		}
		input[type='range']::-ms-fill-lower {
			// this is a style for the track to the left of the slider
			width: 100%;
			height: 0.7rem;
			background-size: 100%;
			background-color: transparent;
			border-radius: 0;
			border: 1px solid $c-slate;
			overflow: visible;
			color: transparent;
		}

		input[type='range']::-ms-fill-upper {
			height: 0.7rem;
			border-radius: 0;
			border: 1px solid $c-slate;
		}
		input[type='range']::-ms-thumb {
			border: 2px solid $c-slate;
			height: 0.7rem;
			width: 0.7rem;
			border-radius: 50%;
			background: #ffffff;
			cursor: pointer;
		}
	}
</style>
